/**
 * violex-cart-drawer.js — Slide-in-Warenkorb-Panel, global auf jeder Seite.
 * Siehe Doku/ux-audit-shop-und-giveaway.md Abschnitt 2+3.
 *
 * Zwei Auslöser:
 *   - Event "violex:cart:add" (violex-product-cart.js, violex-edition.js):
 *     Panel im Bestätigungs-Modus öffnen. Bild/Titel/Variante/Preis kommen
 *     aus der Antwort von /cart/add.js (immer im "items"-Wrapper-Format
 *     aufgerufen) - kein zusätzlicher Request nötig.
 *   - Klick auf [data-vx-cart-trigger] (Warenkorb-Icon im Header): Panel im
 *     Ansichts-Modus öffnen (kein Bestätigungs-Block), aktueller
 *     Warenkorb-Stand per /cart.js.
 *
 * Fortschrittsberechnung teilt sich mit der Warenkorb-Seite die Funktion aus
 * assets/violex-cart-state.js, damit der Gratis-Versand-Status überall
 * gleich ist. Keychain-Upsell (Farb-Swatches direkt im Panel bzw. Links auf
 * die Polo-Seiten in der Gegenrichtung) teilt sich assets/violex-keychain-
 * upsell.js mit der Warenkorb-Seite - beide Dateien müssen VOR dieser hier
 * geladen sein, siehe layout/theme.liquid.
 */
(function () {
  'use strict';

  var KEYCHAIN_HANDLE = 'vlx-nfc-keychain';
  // Fallback, falls die Seite gerade keinen Zugriff auf das echte Section-
  // Setting hat (siehe getShippingCost() unten) - identisch zum Default von
  // "shipping_cost" in cart-with-offers.liquid. Nur eine SCHAETZUNG, deshalb
  // immer mit dem Hinweis "wird an der Kasse final berechnet" zusammen
  // gezeigt (Doku/ux-audit-shop-und-giveaway.md Abschnitt 4).
  var DEFAULT_SHIPPING_COST = 6.9;
  // Echter Tarif aus den Shopify-Versandzonen, null bis die Abfrage
  // zurueckkommt (siehe syncShippingRate weiter unten).
  var realShippingCost = null;
  var POLO_PAGES = [
    { label: 'Day Edition', url: '/pages/day-edition' },
    { label: 'Night Edition', url: '/pages/night-edition' },
  ];
  var offerActive = false;
  var lastFocused = null;
  var closeTimer = null;
  // null = noch nicht geladen, [] = geladen, aber leer - Unterscheidung
  // wichtig, damit ein zweites Oeffnen des Panels nicht erneut nachlaedt.
  var keychainVariants = null;

  var els = {};
  var barEls = {};

  document.addEventListener('DOMContentLoaded', function () {
    els.root = document.getElementById('vx-drawer');
    if (els.root) {
      els.backdrop = document.getElementById('vx-drawer-backdrop');
      els.panel = els.root.querySelector('.vxd__panel');
      els.title = document.getElementById('vx-drawer-title');
      els.closeBtn = document.getElementById('vx-drawer-close');
      els.confirm = document.getElementById('vx-drawer-confirm');
      els.confirmImg = document.getElementById('vx-drawer-confirm-img');
      els.confirmTitle = document.getElementById('vx-drawer-confirm-title');
      els.confirmVariant = document.getElementById('vx-drawer-confirm-variant');
      els.confirmPrice = document.getElementById('vx-drawer-confirm-price');
      els.progress = document.getElementById('vx-drawer-progress');
      els.progressLabel = document.getElementById('vx-drawer-progress-label');
      els.progressBar = document.getElementById('vx-drawer-progress-bar');
      els.upsell = document.getElementById('vx-drawer-upsell');
      els.upsellLabel = document.getElementById('vx-drawer-upsell-label');
      els.upsellDesc = document.getElementById('vx-drawer-upsell-desc');
      els.upsellSwatches = document.getElementById('vx-drawer-upsell-swatches');
      els.upsellStatus = document.getElementById('vx-drawer-upsell-status');
      els.empty = document.getElementById('vx-drawer-empty');
      els.body = document.getElementById('vx-drawer-body');
      els.lines = document.getElementById('vx-drawer-lines');
      els.subtotal = document.getElementById('vx-drawer-subtotal');
      els.shipping = document.getElementById('vx-drawer-shipping');
      els.total = document.getElementById('vx-drawer-total');
      els.continueBtn = document.getElementById('vx-drawer-continue');
      els.viewCart = document.getElementById('vx-drawer-view-cart');

      els.backdrop.addEventListener('click', close);
      els.closeBtn.addEventListener('click', close);
      els.continueBtn.addEventListener('click', close);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && els.root.classList.contains('is-open')) close();
      });

      document.addEventListener('violex:cart:add', function (e) {
        openWithConfirmation(e.detail && e.detail.item);
      });
    }

    document.querySelectorAll('[data-vx-cart-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openCurrentCart(trigger);
      });
    });

    barEls.bar = document.getElementById('vx-nav-offer-bar');
    barEls.label = document.getElementById('vx-nav-offer-bar-label');
    barEls.fill = document.getElementById('vx-nav-offer-bar-fill');

    // Angebotsstatus wie überall sonst aus violex-offer.js beziehen - diese
    // Datei entscheidet nicht selbst, ob ein Angebot existiert.
    if (window.VIOLEX_OFFER_READY) {
      offerActive = !!window.VIOLEX_OFFER;
      refreshHeaderBar();
    } else {
      document.addEventListener(
        'violex:offer:ready',
        function (e) {
          offerActive = !!(e.detail && e.detail.offer);
          refreshHeaderBar();
        },
        { once: true },
      );
    }

    document.addEventListener('violex:cart:updated', refreshHeaderBar);
  });

  // ── Panel öffnen/schliessen ───────────────────────────────────────────────
  async function openWithConfirmation(item) {
    if (!els.root || !item) return;
    lastFocused = document.activeElement;

    els.title.textContent = 'Hinzugefügt';
    els.confirm.hidden = false;
    els.confirmImg.src = item.image || (item.featured_image && item.featured_image.url) || '';
    els.confirmImg.alt = item.title || '';
    els.confirmTitle.textContent = item.product_title || item.title || '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    els.confirmVariant.textContent = variant;
    els.confirmVariant.hidden = !variant;
    els.confirmPrice.textContent = money(item.price);

    open();
    var cart = await fetchCart();
    await renderCartSummary(cart);
  }

  async function openCurrentCart(trigger) {
    if (!els.root) return;
    lastFocused = trigger;
    els.title.textContent = 'Warenkorb';
    els.confirm.hidden = true;

    open();
    var cart = await fetchCart();
    await renderCartSummary(cart);
  }

  function open() {
    clearTimeout(closeTimer);
    els.root.hidden = false;
    // Erst im naechsten Frame die Klasse setzen, sonst greift die
    // transform-Transition nicht (Browser haette hidden->visible und die
    // Transform-Aenderung im selben Layout-Tick, keine sichtbare Animation).
    requestAnimationFrame(function () {
      els.root.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', trapFocus);
    els.panel.focus();
  }

  function close() {
    if (!els.root) return;
    els.root.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', trapFocus);
    // An die CSS-Transition-Dauer angleichen (siehe violex-cart-drawer.css,
    // .vxd__panel transition: 0.32s) - sonst verschwindet das Panel per
    // display:none, bevor die Schliess-Animation zu Ende gelaufen ist.
    closeTimer = setTimeout(function () {
      els.root.hidden = true;
    }, 320);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  // Fokus im Panel halten, solange es offen ist (Tab am Ende springt zum
  // Anfang zurueck und umgekehrt) - das Panel ist zwar kein echtes Modal
  // (Doku §10), Tastaturnutzer sollen aber trotzdem nicht unbemerkt hinter
  // den Backdrop tabben.
  function trapFocus(e) {
    if (e.key !== 'Tab' || !els.panel) return;
    var focusable = els.panel.querySelectorAll('a[href], button:not([disabled])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  async function renderCartSummary(cart) {
    if (!cart) return;

    // Leer-Zustand (Wunsch Tomas, 29.08.2026): bei 0 Artikeln zeigen wir
    // weder Positionsliste noch eine Zwischensumme/Versand/Gesamt von
    // CHF 0.00, sondern nur den Hinweis-Block mit "Jetzt shoppen"-CTA.
    var isEmpty = !cart.item_count;
    if (els.empty) els.empty.hidden = !isEmpty;
    if (els.body) els.body.hidden = isEmpty;
    if (isEmpty) return;

    els.viewCart.textContent =
      'Warenkorb ansehen (' + cart.item_count + (cart.item_count === 1 ? ' Artikel' : ' Artikel') + ') →';

    var progress = window.ViolexCartState.computeOfferProgress(cart, offerActive, KEYCHAIN_HANDLE);
    els.progress.hidden = !progress.active;
    if (progress.active) {
      els.progressLabel.textContent = progress.label;
      els.progressBar.style.width = progress.percent + '%';
      els.progress.classList.toggle('is-complete', progress.freeShippingActive);
    }

    renderLines(cart);
    renderTotals(cart, progress.freeShippingActive);
    await renderUpsell(progress);

    // Echte Versandkosten nachziehen - bewusst ohne await: das Panel steht
    // schon vollstaendig da, der Betrag korrigiert sich gleich darauf.
    syncShippingRate(cart);
  }

  // ── Positionsliste + Zwischensumme/Versand/Gesamt (Wunsch Tomas,
  // 29.08.2026: "Preis für Polo + Keychain und Versand dynamisch") ──────────
  function renderLines(cart) {
    if (!els.lines) return;
    // Bewusst immer gezeigt, unabhaengig vom Modus (Wunsch Tomas,
    // 29.08.2026: "wollte nie, dass sich das Panel je nach Modus anpasst" -
    // ein frueherer Versuch, dies im Hinzugefuegt-Modus wegen vermeintlicher
    // Dopplung zu verstecken, wurde deshalb wieder rueckgaengig gemacht).
    els.lines.innerHTML = cart.items
      .map(function (item) {
        var variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? '<span class="vxd__line-variant">' + escHtml(item.variant_title) + '</span>'
            : '';
        var qty = item.quantity > 1 ? ' ×' + item.quantity : '';
        return (
          '<div class="vxd__line">' +
          '<span class="vxd__line-title">' + escHtml(item.product_title || item.title) + qty + variant + '</span>' +
          '<span class="vxd__line-price">' + money(item.final_line_price != null ? item.final_line_price : item.line_price) + '</span>' +
          '</div>'
        );
      })
      .join('');
  }

  function renderTotals(cart, freeShippingActive) {
    var subtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    els.subtotal.textContent = money(subtotal);

    var shippingCost = getShippingCost();
    if (els.shipping) {
      els.shipping.textContent = freeShippingActive ? 'Gratis' : 'ab ' + money(shippingCost * 100);
    }

    var total = freeShippingActive ? subtotal : subtotal + shippingCost * 100;
    if (els.total) els.total.textContent = money(total);
  }

  /** Section-Setting "shipping_cost" von cart-with-offers.liquid, falls die
   *  Section auf der aktuellen Seite existiert (also auf /pages/order) - das
   *  Panel kennt es sonst nicht, da es global auf JEDER Seite oeffnen kann.
   *  Fallback DEFAULT_SHIPPING_COST ansonsten.
   *
   *  Nur noch der STARTWERT, bis die echten Versandkosten aus den
   *  Shopify-Versandzonen da sind (siehe syncShippingRate unten,
   *  29.08.2026). Immer als "ab CHF …" dargestellt, nie als Endbetrag -
   *  das Zielland steht erst im Checkout fest. */
  function getShippingCost() {
    if (realShippingCost !== null) return realShippingCost;
    var root = document.getElementById('violex-cart');
    var raw = root && parseFloat(root.dataset.shippingCost);
    return isNaN(raw) ? DEFAULT_SHIPPING_COST : raw;
  }

  /** Holt die echten Versandkosten (assets/violex-cart-state.js) und rendert
   *  die Summe neu, sobald sie da sind. Dieselbe Quelle wie die
   *  Warenkorb-Seite, damit Panel und Seite nie unterschiedliche Betraege
   *  zeigen. Schlaegt die Abfrage fehl, bleibt es beim Startwert. */
  async function syncShippingRate(cart) {
    var state = window.ViolexCartState;
    if (!state || !state.fetchDomesticShippingRate || !cart) return;

    var rate = await state.fetchDomesticShippingRate(cart);
    if (rate === null || rate === realShippingCost) return;

    realShippingCost = rate;
    var progress = state.computeOfferProgress(cart, offerActive, KEYCHAIN_HANDLE);
    renderTotals(cart, progress.freeShippingActive);
  }

  // ── Keychain-Upsell (Doku §2+3, beide Richtungen) ──────────────────────────
  async function renderUpsell(progress) {
    if (!els.upsell) return;

    // Nur zeigen, wenn ein Angebot aktiv ist UND genau ein Artikel fehlt -
    // weder wenn es kein Angebot gibt, noch wenn der Warenkorb es schon
    // erfuellt (dann uebernimmt der "freigeschaltet"-Fortschrittsbalken).
    if (!progress.active || progress.freeShippingActive) {
      els.upsell.hidden = true;
      return;
    }

    var needsKeychain = progress.hasOther && !progress.hasKeychain;
    var needsOther = progress.hasKeychain && !progress.hasOther;
    if (!needsKeychain && !needsOther) {
      els.upsell.hidden = true;
      return;
    }

    els.upsell.hidden = false;
    hideUpsellStatus();

    // Umgekehrter Fall: nur ein Keychain im Warenkorb. Hier gibt es nichts per
    // Swatch hinzuzufuegen (ein Polo braucht eine Groessenwahl), deshalb
    // fuehren zwei Links auf die Produktseiten statt eines Direkt-Buttons -
    // exakt dasselbe Muster wie auf der Warenkorb-Seite.
    if (needsOther) {
      els.upsellLabel.textContent = '✦ Polo hinzufügen — Gratis-Versand';
      els.upsellDesc.textContent =
        'Dein Keychain schaltet den Gratis-Versand frei, sobald ein weiterer Artikel dazukommt.';
      els.upsellSwatches.innerHTML = POLO_PAGES.map(function (polo) {
        return '<a class="vxd-btn vxd-btn--outline" href="' + polo.url + '">' + polo.label + ' ansehen →</a>';
      }).join('');
      return;
    }

    els.upsellLabel.textContent = '✦ Keychain hinzufügen — Gratis-Versand';

    if (keychainVariants === null) {
      els.upsellDesc.textContent = 'Keychain-Farben werden geladen …';
      keychainVariants = await window.ViolexKeychainUpsell.fetchVariants(KEYCHAIN_HANDLE);
    }

    var kp = window.ViolexKeychainUpsell.firstAvailablePrice(keychainVariants);
    els.upsellDesc.textContent = kp !== null
      ? 'Keychain für CHF ' + kp.toFixed(2) + ' — schaltet den Gratis-Versand frei.'
      : 'Ergänze einen Keychain — schaltet den Gratis-Versand frei.';

    window.ViolexKeychainUpsell.renderSwatches(
      els.upsellSwatches,
      keychainVariants,
      '/pages/keychain',
      onPickKeychain,
    );
  }

  async function onPickKeychain(variantId, swatchEl) {
    hideUpsellStatus();
    var group = swatchEl.closest('.vx-swatches');
    group.querySelectorAll('.vx-swatch').forEach(function (btn) {
      btn.disabled = true;
    });
    swatchEl.classList.add('active');

    try {
      await window.ViolexKeychainUpsell.addVariant(variantId);
      showUpsellStatus('✓ Keychain liegt im Warenkorb.', 'success');
      var cart = await fetchCart();
      await renderCartSummary(cart);
      // Dispatch statt direktem Aufruf: refreshHeaderBar() haengt bereits als
      // Listener an diesem Event (siehe DOMContentLoaded oben) UND violex-
      // home.js braucht es, um den Zaehler am Warenkorb-Icon nachzuziehen.
      document.dispatchEvent(new CustomEvent('violex:cart:updated', { detail: { count: cart && cart.item_count } }));
    } catch (err) {
      showUpsellStatus(err.message || 'Keychain konnte nicht hinzugefügt werden. Bitte erneut versuchen.', 'error');
      group.querySelectorAll('.vx-swatch').forEach(function (btn) {
        btn.disabled = false;
      });
      swatchEl.classList.remove('active');
      console.error('onPickKeychain failed', err);
    }
  }

  function showUpsellStatus(message, kind) {
    if (!els.upsellStatus) return;
    els.upsellStatus.textContent = message;
    els.upsellStatus.className = 'vxd__upsell-status is-' + kind;
    els.upsellStatus.hidden = false;
  }

  function hideUpsellStatus() {
    if (!els.upsellStatus) return;
    els.upsellStatus.hidden = true;
  }

  // ── Header-Leiste (Doku §3, dritte Stelle) ─────────────────────────────────
  async function refreshHeaderBar() {
    if (!barEls.bar) return;
    var cart = await fetchCart();
    var progress = cart ? window.ViolexCartState.computeOfferProgress(cart, offerActive, KEYCHAIN_HANDLE) : null;

    var wasHidden = barEls.bar.hidden;
    if (!progress || !progress.active) {
      barEls.bar.hidden = true;
    } else {
      barEls.bar.hidden = false;
      barEls.label.textContent = progress.label;
      barEls.fill.style.width = progress.percent + '%';
      barEls.bar.classList.toggle('is-complete', progress.freeShippingActive);
    }

    // Die Leiste liegt IN der Nav und veraendert dadurch deren Hoehe - ohne
    // Nachziehen bliebe --violex-nav-height (violex-home.js, ueber
    // #MainContent padding-top wirksam) auf dem alten Wert stehen und der
    // Seiteninhalt ueberlappt die Nav oder es klafft eine Luecke. Statt die
    // Berechnung hier zu duplizieren: ein synthetisches "resize" ausloesen,
    // das setNavHeightVar() in violex-home.js ohnehin schon dafuer hat.
    if (wasHidden !== barEls.bar.hidden) {
      window.dispatchEvent(new Event('resize'));
    }
  }

  // ── Helfer ───────────────────────────────────────────────────────────────
  async function fetchCart() {
    try {
      var res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return null;
      return await res.json();
    } catch (_e) {
      return null;
    }
  }

  function money(value) {
    return 'CHF ' + (Number(value || 0) / 100).toFixed(2);
  }

  function escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
})();
